module.exports = __webpack_public_path__ + "img/Weapon_128.013ea88c.png";